export default "__VITE_ASSET__c8169d45__"